<template>
    <div class="sm:max-w-4xl mx-auto">
        <resource-index title="Клиенты" endpoint="admin/customers">
            <template slot="header-buttons">
                <router-link
                    class="btn btn-secondary"
                    :to="{
                    name: 'admin.customers.create',
                }"
                >Создать</router-link>
            </template>

            <template v-slot:table-header>
                <tr class="border-b">
                    <th class="text-left p-3 px-5" scope="col">Имя</th>
                    <th class="text-left p-3 px-5" scope="col">Номер телефона</th>
                    <th class="text-left p-3 px-5" scope="col">Email</th>
                    <th class="text-left p-3 px-5" scope="col"></th>
                </tr>
            </template>

            <template v-slot:table-filters="slotProps">
                <tr class="border-b bg-gray-100">
                    <th class="p-3 px-5" scope="col">
                        <text-field :wrap="false" v-model="slotProps.filters.name" />
                    </th>

                    <th class="p-3 px-5" scope="col">
                        <text-field :wrap="false" v-model="slotProps.filters.phone" />
                    </th>

                    <th class="p-3 px-5" scope="col">
                        <text-field :wrap="false" v-model="slotProps.filters.email" />
                    </th>

                    <th class="p-3 px-5" scope="col"></th>
                </tr>
            </template>

            <template v-slot:row="slotProps">
                <td class="p-3 px-5">{{ slotProps.entry.full_name }}</td>

                <td class="p-3 px-5">{{ slotProps.entry.phone }}</td>

                <td class="p-3 px-5">{{ slotProps.entry.email }}</td>

                <td class="p-3 px-5">
                    <router-link
                        :to="{
                        name: 'admin.customers.edit',
                        params: {
                            id: slotProps.entry.id
                        }
                    }"
                        class="btn btn-info"
                    >Изменить</router-link>
                </td>
            </template>
        </resource-index>
    </div>
</template>

<script>
import ResourceIndex from "@/components/Resource/ResourceIndex";

export default {
    components: {
        ResourceIndex
    }
};
</script>